import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-5 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 items-center justify-center transition-all duration-300 hover:bg-primary-600 ${
        show ? "flex opacity-100 translate-y-0" : "hidden opacity-0 translate-y-3"
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}